import { render, staticRenderFns } from "./ImageVideoView.vue?vue&type=template&id=33fd7626&scoped=true&"
import script from "./ImageVideoView.vue?vue&type=script&lang=js&"
export * from "./ImageVideoView.vue?vue&type=script&lang=js&"
import style0 from "./ImageVideoView.vue?vue&type=style&index=0&id=33fd7626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd7626",
  null
  
)

export default component.exports